<template>
    <div class="submitShoppingCart" @click="startBooking">{{buttonName}}</div>
</template>

<script>
import api from '@/api'
import bookingHelper from '@/utilities/bookingHelper'
export default {
    name: "SubmitShoppingCartButton",
    props: {
        shoppingCarts: {
            type: Array
        },
        buttonName: {
            type: String,
            default: "下一步 乘客信息"
        },
        isRow: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        // 开始预订，第一步调用InitStateroom接口初始化预订流程
        // 第二步循环购物车，调用select stateroom接口锁舱
        // 最后一步调用check coupon接口检查是否有赠送优惠券
        async startBooking () {
            if (this.isRow) return
            if (this.shoppingCarts.length == 0) return
            const shipCode = this.shoppingCarts[0].shipCode
            const sailDate = this.shoppingCarts[0].sailDate
            this.$loading.show()
            let bookingKey = this.$store.state.booking.bookingKey
            const { success, data, errMsg } = await api.booking.initStateroom(bookingKey)
            this.$loading.hide()
            if (!success) {
                this.$alert.show(errMsg)
                return
            } else {
                this.$store.commit('SET_BOOKING_KEY', data)
                bookingKey = data
            }
            const result = await this.selectStateroomApi(bookingKey)
            if (result.successShoppingCarts.length > 0 && result.failureShoppingCarts.length == 0) {
                // 全部成功，进入下一步
                this.goToGuestInfo(shipCode, sailDate, result.successShoppingCarts)
            } else if (result.failureShoppingCarts.length > 0) {
                if (result.successShoppingCarts.length == 0) {
                    // 全部失败，提示重新选择
                    const staterooms = result.failureShoppingCarts.filter(r=>r.stateroomPartRecord && r.stateroomPartRecord.cnName)
                    .map(r=>r.stateroomPartRecord.cnName)
                    this.$alert.show(`您选择的${staterooms.join('，')}已经售罄，已为您删除，您可以返回重新选择。`)

                } else if (result.successShoppingCarts.length > 0) {
                    // 有成功有失败，用户自己选择继续还是重新选择
                    const staterooms = result.failureShoppingCarts.filter(r=>r.stateroomPartRecord && r.stateroomPartRecord.cnName)
                    .map(r=>r.stateroomPartRecord.cnName)
                    this.$confirm.show(`您选择的${staterooms.join('，')}已经售罄，已为您删除，您可以继续填写乘客信息或者返回重新选择。`, {
                        confirmBtn: '填写乘客信息',
                        cancelBtn: '返回重新选择',
                        confirmCallBack: ()=> {
                            this.goToGuestInfo(shipCode, sailDate, result.successShoppingCarts)
                        }
                    })
                }

                // 删除失败的房间
                const failureConnects = result.failureShoppingCarts.filter(r=>r.connectId && r.connectId.length > 0)
                const failureNormals = result.failureShoppingCarts.filter(r=>!r.connectId || r.connectId=='')
                if (failureConnects.length > 0) {
                    this.onShoppingCartDelete(failureConnects[0])
                }
                if (failureNormals.length > 0) {
                    failureNormals.forEach((sc) => {
                        this.onShoppingCartDelete(sc)
                    })
                }
            }
        },
        // 提交购物车各个舱房
        // 返回定义, successShoppingCarts: [], failureShoppingCarts: []
        async selectStateroomApi (bookingKey) {
            this.$loading.show()
            let result = {
                successShoppingCarts: [],
                failureShoppingCarts: []
            }
            // 先处理连通房，如果连通房有一间不成功，那都不成功
            if (this.connectRooms.length == 2) {
                for (let i = 0; i < this.connectRooms.length; i++) {
                    const shoppingCart = this.connectRooms[i]
                    const requestData = this.getSelectStateroomRequest(bookingKey, shoppingCart)
                    const { success } = await api.booking.selectStateroom(requestData)
                    if (!success) {
                        result.successShoppingCarts = []
                        result.failureShoppingCarts = result.failureShoppingCarts.concat(this.connectRooms)
                        break
                    } else {
                        result.successShoppingCarts.push(shoppingCart)
                    }
                }
            }

            // 处理普通房型
            if (this.noConnectRooms.length > 0) {
                for (let i = 0; i < this.noConnectRooms.length; i++) {
                    let shoppingCart = this.noConnectRooms[i]
                    const requestData = this.getSelectStateroomRequest(bookingKey, shoppingCart)
                    const { success } = await api.booking.selectStateroom(requestData)
                    if (!success) {
                        result.failureShoppingCarts.push(shoppingCart)
                    } else {
                        result.successShoppingCarts.push(shoppingCart)
                    }
                }
            }
            this.$loading.hide()

            try {
                if(window && window.gio){
                    const shipCode = this.shoppingCarts[0].shipCode
                    const sailDate = this.shoppingCarts[0].sailDate
                    window.gio('app.set', 'ShipCode', shipCode)
                    window.gio('app.set', 'SailDate', sailDate)
                }
            } catch (e) {
                console.error(e)
            }

            return result
        },
        // 组装select stateroom request
        getSelectStateroomRequest (bookingKey, shoppingCart) {
            let requestData = {
                bookingKey,
                sailDate: shoppingCart.sailDate,
                shipCode: shoppingCart.shipCode,
                stateroomCategoryCode: shoppingCart.berthedCategoryCode,
                fareCode: shoppingCart.fareCode,
                agencyId: this.agencyId,
                guestNumber: shoppingCart.guestNumber,
                isnrp: shoppingCart.isnrp,
                groupAgencyId: shoppingCart.groupAgencyId || '', 
                groupAgencyName: shoppingCart.groupAgencyName || '',
                requestSequence: shoppingCart.requestSequence || '',
                groupType: shoppingCart.groupType || '',
                groupId: shoppingCart.groupId || '',
                connectId: shoppingCart.connectId || '',
                isConnectRoom: (shoppingCart.connectId && shoppingCart.connectId.length > 0),
                source: "online"
            }

            try {
                if(window && window.gio){
                    if(requestData.isnrp){
                        window.gio('track', 'NRP_BF02');
                    }
                }
            } catch (e) {
                console.error(e)
            }

            return requestData
        },
        // 检查是否有赠送优惠券，并进入填写信息页面
        async goToGuestInfo (shipCode, sailDate, successShoppingCarts) {
            const stateroomCodes = successShoppingCarts.map(r=>r.berthedCategoryCode)
            const requestData = {
                request: {
                    shipCode: shipCode,
                    sailDate: sailDate,
                    stateroomCategoryCodes: stateroomCodes
                }
            }
            this.$loading.show()
            const { success, data } = await api.booking.checkCoupon(requestData)
            this.$loading.hide()
            if (!success || !data || !data.couponInfos || data.couponInfos.length == 0) {
                 this.$router.push({
                    name: "GuestInfo",
                    query: {
                        shipCode,
                        sailDate
                    }
                })
                return 
            }
            let text = '您已领取了 ';
            let couponText = "";
            for (var i = 0; i < data.couponInfos.length; i++) {
                var couponInfo = data.couponInfos[i];
                if (couponInfo.getCount > 0) {
                    couponText += "，" + couponInfo.getCount + "张" + couponInfo.couponType;
                }
            }
            if (couponText.length > 0) {
                couponText = couponText.substr(1);
                text = text + couponText + "，可在下一乘客信息填写页面选择使用优惠券"
                const self = this
                this.$alert.show(text, {
                    confirmCallBack: () => {
                        self.$router.push({
                            name: "GuestInfo",
                            query: {
                                shipCode,
                                sailDate
                            }
                        })
                    }
                })
            } else {
                this.$router.push({
                    name: "GuestInfo",
                    query: {
                        shipCode,
                        sailDate
                    }
                })
            }
        },
        deleteShoppingCarts(shoppingCarts) {
            shoppingCarts.forEach((shoppingCart)=> {
                this.onShoppingCartDelete(shoppingCart)
            })
        },
        async onShoppingCartDelete(stateroomData) {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                let self = this
                this.$confirm.show('您尚未登录， 请登录之后， 再添加舱房', {
                    confirmCallBack () {
                        self.$router.push({ name: 'Login', query:{ 
                            returnUrl: location.href
                        }})
                    }
                })
                return
            }
            let requestData = {
                viewModel: {
                    sailDate: stateroomData.sailDate,
                    shipCode: stateroomData.shipCode,
                    guestNumber: stateroomData.guestNumber,
                    stateroomCategoryCode: stateroomData.berthedCategoryCode,
                    connectId: stateroomData.connectId,
                    isNrp: stateroomData.isnrp
                }
            }
            this.$loading.show()
            const { success } = await api.booking.deleteShoppingCart(requestData)
            if (!success) {
                // this.$alert.show(errMsg)
            }
            this.$loading.hide()
            this.getShoppingCart()
        },
        getShoppingCart() {
            this.$store.dispatch('GET_SHOPPING_CART')
        }
    },
    computed: {
        connectRooms () {
            return this.shoppingCarts.filter(r=>r.connectId && r.connectId.length > 0)
        },
        noConnectRooms () {
            return this.shoppingCarts.filter(r=>!r.connectId || r.connectId.length == 0)
        },
        userInfo () {
            return this.$store.state.user.userInfo
        },
        pppKey () {
            return this.$store.state.user.pppKey
        },
        isPPP () {
            if (this.pppKey && this.pppKey.length > 0 && this.userInfo && this.userInfo.isPartner) {
                return true
            }
            return false
        },
        agencyId () {
            return this.isPPP ? bookingHelper.pppAgencyId:bookingHelper.agencyId
        }
    }
}
</script>

<style lang="less" scoped>
.submitShoppingCart {
    cursor: pointer;
}
</style>